import { Modal, Button } from "@biteship/atom";
import { ReactComponent as Illustration } from "./success-image.svg";

export default function (props) {
  return (
    <Modal show={props.show} className="md:max-w-3xl w-full md:px-16 p-8" onClose={props.onClose}>
      <div className="flex flex-col w-full items-center space-y-4">
        <Illustration />
        <h5 className="text-center">Tiket bantuan berhasil dibuat!</h5>
        <p className="text-gray-800 text-base text-center">
          Tim kami akan segera merespon kendala Anda, silahkan cek kolom komentar secara berkala.
        </p>
        <Button
          className="w-full justify-center my-2"
          title={<div className="font-bold">Kembali</div>}
          onClick={() => props.onClose()}
        />
      </div>
    </Modal>
  );
}
